<template>
  <section>
    <b-tag class="score" :style="{'color':colorTag}" v-if="score  && !toPage">{{formatedText}}</b-tag>
    <b-button class="score" type="is-light" tag="router-link" :style="{'color':colorTag}" :to="toPage" v-else-if="toPage && score">{{formatedText}}</b-button>
    <span class="tag is-light score" v-else>Sin Evaluar</span>
  </section>
</template>

<script>
export default {
  data () {
    return {
      minScore: 60
    }
  },
  props: {
    score: {
      required: false
    },
    percent: {
      required: false,
      type: Boolean,
      default: true
    },
    toPage: {
      required: false,
      type: Object
    }
  },
  computed: {
    colorTag () {
      return this.score > this.minScore ? '#23d160' : '#ff3860'
    },
    value () {
      if (this.score == null) {
        return 'Pendiente'
      } else {
        return this.score
      }
    },
    formatedText () {
      return `${this.score.toFixed(2)}${this.percent ? '%' : ''}`
    }
  }
}
</script>

<style scoped>
  .score{
    font-size: 0.9rem;
    font-weight: 900;
  }
</style>
